import Base from "../../base";
import SideMenu from "../SideMenu";
import LeftMenu from "../../../components/LeftMenu";
import Header from "../Header";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { faEdit, faTrashAlt, faTags } from "@fortawesome/pro-regular-svg-icons";
import Swal from "sweetalert2";
import Pagination from "../../../components/ui/Pagination";
import axiosConfig from "../../../services/Axios";
import CategorieCreateForm from "./CategorieCreateForm";
import { toast } from "react-toastify";
import Title from "../../../components/ui/Title";
import EmptyData from "../../../components/ui/EmptyData";
import LabelCount from "../../../components/ui/LabelCount";
import PopoverMenu from "../../../components/ui/PopoverMenu";
import { useTranslation } from "react-i18next";

function Categories() {
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState();
  const { t } = useTranslation();
  const [modalCategorieFormIsOpen, setModalCategorieFormIsOpen] =
    useState(false);

  const loadCategories = () => {
    let itemsPerPage = 10;
    let url =
      process.env.REACT_APP_API_URL +
      (formData?.page ? formData?.page + "&" : "/api/item_categories?");

    if (itemsPerPage) {
      url = url + "&itemsPerPage=" + itemsPerPage;
    }

    axiosConfig.get(url).then((response) => {
      if (response?.status === 200 && response?.data) {
        setCategories(response.data);
      }
    });
  };

  useEffect(() => {
    loadCategories();
  }, [formData]);

  const openModalCategorie = async () => {
    setModalCategorieFormIsOpen(true);
  };

  const handleDeleteCategorie = (categorie) => {
    Swal.fire({
      text: t("global.form.delete") + " " + categorie.name + " ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.confirm_delete"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          axiosConfig
            .delete(process.env.REACT_APP_API_URL + categorie["@id"])
            .then((response) => {
              if (response?.status === 204) {
                toast.success(t("categories.deleted"), {
                  theme: "colored",
                  hideProgressBar: true,
                });
                loadCategories();
              }
            });
        } catch (e) {
          if (
            e.response?.status !== 200 &&
            e.response?.data["hydra:description"]
          ) {
            toast.error(e.response?.data["hydra:description"]);
          }
        }
      }
    });
  };

  return (
    <Base>
      <Header />
      <div className="py-16 container m-auto px-6 grid grid-cols-12">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2">
          <LeftMenu menu={SideMenu} />
        </div>
        <div className="lg:ml-6 lg:p-8 lg:px-10 text-sm mt-10 lg:mt-0 col-span-12 lg:col-span-9 xl:col-span-10 lg:bg-white rounded-lg">
          <Title
            icon={faTags}
            title={t("settings.categories.list")}
            button={{
              label: t("categories.create"),
              fn: () => openModalCategorie(null),
            }}
          />

          <div className="bg-bioport-blue-light grid grid-cols-12 text-white font-bold px-4 p-3">
            <div className="col-span-7 lg:col-span-9">
              {t("categories.name")}
            </div>
            <div className="col-span-4 lg:col-span-2 text-center">
              {t("categories.sub-categories.list")}
            </div>
            <div className="col-span-1 text-center"></div>
          </div>

          {categories &&
            categories["hydra:member"] &&
            (categories["hydra:totalItems"] === 0 ? (
              <EmptyData className="mt-3">{t("global.no-result")}</EmptyData>
            ) : (
              categories["hydra:member"].map((c, key) => (
                <div
                  className={`grid grid-cols-12 px-4 p-3 hover:bg-gray-50 ${
                    key % 2 === 0 && "bg-gray-100"
                  }`}
                  key={key}
                >
                  <div className="col-span-7 lg:col-span-9">
                    <Link
                      to={`/settings/categories/${c.id}`}
                      className="hover:underline"
                    >
                      {c.name}
                    </Link>
                  </div>
                  <div className="col-span-4 lg:col-span-2 text-center">
                    <Link to={`/settings/categories/${c.id}`}>
                      <LabelCount
                        count={c.itemSubCategories.length}
                        defaultClass="bg-gray-300"
                        enabledClass="bg-bioport-blue text-white"
                      />
                    </Link>
                  </div>
                  <div className="col-span-1 text-center">
                    <PopoverMenu
                      links={[
                        {
                          link: "/settings/categories/" + c.id,
                          icon: faEdit,
                          label: t("global.edit"),
                          class:
                            "hover:cursor-pointer hover:underline text-bioport-blue mb-2",
                        },
                        {
                          link: () => handleDeleteCategorie(c),
                          icon: faTrashAlt,
                          label: t("global.form.delete"),
                          class:
                            "hover:cursor-pointer hover:underline text-red-600",
                        },
                      ]}
                    />
                  </div>
                </div>
              ))
            ))}

          {categories &&
            categories["hydra:member"] &&
            categories["hydra:totalItems"] >
              categories["hydra:member"].length &&
            categories["hydra:view"] && (
              <Pagination
                data={categories}
                onClick={(page) => {
                  setFormData((formData) => ({
                    ...formData,
                    page: page,
                  }));
                }}
              />
            )}
        </div>
        <CategorieCreateForm
          setModalCategorieFormIsOpen={setModalCategorieFormIsOpen}
          modalCategorieFormIsOpen={modalCategorieFormIsOpen}
          loadCategories={loadCategories}
        />
      </div>
    </Base>
  );
}

export default Categories;
